import React from 'react';
import { useTranslation } from 'react-i18next';
import { LayoutDashboard, Gamepad2, Building2, PieChart, Trophy } from 'lucide-react';
import type { GameSubTab } from './useGameFilters';

interface GameSubTabNavProps {
  active: GameSubTab;
  onChange: (tab: GameSubTab) => void;
}

export const GameSubTabNav: React.FC<GameSubTabNavProps> = ({ active, onChange }) => {
  const { t } = useTranslation();
  const tabs: { key: GameSubTab; label: string; Icon: React.ComponentType<{ className?: string }> }[] = [
    { key: 'overview', label: t('gamePerformance.tabOverview',      { defaultValue: 'Overview' }),       Icon: LayoutDashboard },
    { key: 'games',    label: t('gamePerformance.tabGamePerformance',{ defaultValue: 'Game Performance' }), Icon: Gamepad2 },
    { key: 'brands',   label: t('gamePerformance.tabBrandMargin',   { defaultValue: 'Brand Margin' }),   Icon: Building2 },
    { key: 'mix',      label: t('gamePerformance.tabGameTypeMix',   { defaultValue: 'Game Type Mix' }),  Icon: PieChart },
    { key: 'top',      label: t('gamePerformance.tabTopGames',      { defaultValue: 'Top Games' }),      Icon: Trophy },
  ];

  return (
    <div className="flex flex-wrap gap-2 border-b border-slate-200 dark:border-slate-700">
      {tabs.map(({ key, label, Icon }) => {
        const isActive = active === key;
        return (
          <button
            key={key}
            onClick={() => onChange(key)}
            className={`flex items-center gap-2 rounded-t-lg px-4 py-2 text-sm font-medium transition-colors -mb-px ${
              isActive
                ? 'border-x border-t border-slate-200 border-b-white bg-white text-accent dark:border-slate-700 dark:border-b-slate-900 dark:bg-slate-900 dark:text-accent'
                : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-white'
            }`}
          >
            <Icon className="h-4 w-4" />
            {label}
          </button>
        );
      })}
    </div>
  );
};
